import React from 'react';
import Box from '../components/Box';

export const AboutWebUI = () => {
  return (
    <Box style={{ background: '#F8F8F8' }}>
      <h2 className='mt0 mb3 arial fw2 f3 charcoal'>What is THDJBR?</h2>
      <ul className='pl3'>
          <li className='mb2'><span className='greenmod u'>Reserve a Jabra</span>&nbsp;&mdash; Our dapp saves your reservations in the blockchain of Ethereum.</li>
          <li className='mb2'><span className='greenmod u'>Cancel a Jabra</span>&nbsp;&mdash; You can cancel reservations anytime.</li>
          <li className='mb2'><span className='greenmod u'>Send reservations</span>&nbsp;&mdash; You can send another your reservations each other.</li>
          <li className='mb2'><span className='greenmod u'>Search reservations</span>&nbsp;&mdash; You can see anyone's reservations.</li>
          <li className='mb2'><span className='greenmod u'>Administered by the system owner</span>&nbsp;&mdash; The system owner, the system department, can execute any operations such as canceling your reservations, etc.</li>
      </ul>
    </Box>
  )
}

export default AboutWebUI;
